import React, { type JSX } from 'react';
import { Box, Divider, Stack, Typography } from '@mui/material';
import { CustomModal } from './CustomModal';
import { GroupPath } from './GroupPath';
import { useTypedSelector, useAppDispatch } from '@fiji/common/src/app/store';
import { clearFailedLoadTrigger } from '@fiji/common/src/features/loadGroups/loadGroupsSlice';

export const FailedLoadTriggerModal = (props: any): JSX.Element => {
    const dispatch = useAppDispatch();
    const { failedLoadTrigger, isFailedLoadModalOpen } = useTypedSelector((state) => state.loadGroups);

    const resolvedFailedLoadTrigger = failedLoadTrigger ?? {};
    const failedLoadsList = Array.isArray(resolvedFailedLoadTrigger?.Load) ? resolvedFailedLoadTrigger.Load : [];
    const failedLoadsCount =
        resolvedFailedLoadTrigger?.failedLoads ?? (failedLoadsList.length ? failedLoadsList.length : 0);
    const totalLoadsCount = resolvedFailedLoadTrigger?.totalLoads ?? failedLoadsCount;
    const failedLoadActionLabel = resolvedFailedLoadTrigger?.isEnabled ? 'On' : 'Off';
    const loadGroupName =
        (Array.isArray(resolvedFailedLoadTrigger?.groupPath) && resolvedFailedLoadTrigger?.groupPath?.length
            ? resolvedFailedLoadTrigger?.groupPath?.[resolvedFailedLoadTrigger.groupPath.length - 1]
            : resolvedFailedLoadTrigger?.loadGroupName) ||
        resolvedFailedLoadTrigger?.loadGroupId ||
        '';
    const failedLoadSubHeader = `There was an error turning the following ${failedLoadsCount} of ${totalLoadsCount} load(s) ${failedLoadActionLabel.toLowerCase()}${
        loadGroupName ? ` within the load group "${loadGroupName}".` : '.'
    }`;

    return (
        <CustomModal
            isOpen={isFailedLoadModalOpen}
            type="primary"
            header={`Error Turning Load(s) ${failedLoadActionLabel}`}
            subHeader={failedLoadSubHeader}
            actions={[
                {
                    key: 'ok',
                    label: 'OK',
                    variant: 'contained',
                    close: true,
                    handleClick: (): void => {
                        if (props?.onClose) props.onClose();
                        dispatch(clearFailedLoadTrigger());
                    },
                },
            ]}
            hidePadding
            actionsDivider
        >
            <Stack divider={<Divider flexItem />} sx={{ maxHeight: '320px', overflowY: 'auto' }}>
                {failedLoadsList?.length ? (
                    failedLoadsList.map((load: any, index: number) => (
                        <Stack
                            key={load?.id ?? load?.loadId ?? `${index}`}
                            direction="row"
                            spacing={2}
                            px={3}
                            py={2}
                            alignItems="center"
                        >
                            <Box sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: '#727E84' }} />
                            <Stack>
                                <Typography fontWeight={600} fontSize={14} color="#424e54">
                                    {load?.name ?? load?.loadName ?? `Load ${index + 1}`}
                                </Typography>
                                {(Array.isArray(load?.groupPath) ||
                                    Array.isArray(resolvedFailedLoadTrigger?.groupPath) ||
                                    load?.deviceName) && (
                                    <GroupPath
                                        pathName={load?.groupPath ?? resolvedFailedLoadTrigger?.groupPath ?? []}
                                        deviceName={load?.deviceName}
                                        width="340px"
                                    />
                                )}
                            </Stack>
                        </Stack>
                    ))
                ) : (
                    <Typography px={3} py={2} variant="body2" color="#727E84">
                        No failed loads received.
                    </Typography>
                )}
            </Stack>
        </CustomModal>
    );
};
